var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 928c46.933 0 85.333-38.4 85.333-85.333H426.666c0 46.933 38.4 85.333 85.333 85.333zm256-256V458.667c0-130.987-69.547-240.64-192-269.653v-29.013c0-35.413-28.587-64-64-64s-64 28.587-64 64v29.013c-122.027 29.013-192 138.24-192 269.653V672l-85.333 85.333V800h682.667v-42.667L768.001 672zm-85.333 42.667H341.334v-256c0-105.813 64.427-192 170.667-192s170.667 86.187 170.667 192z"
  })));
};
export default SvgNotifications;